import { render, staticRenderFns } from "./BizChainEditor.vue?vue&type=template&id=a153ba6c&scoped=true&"
import script from "./BizChainEditor.vue?vue&type=script&lang=js&"
export * from "./BizChainEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a153ba6c",
  null
  
)

export default component.exports